import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import CustomButton, {
  CustomButtonVariant,
} from "../CustomButton/CustomButton";

export interface DetailItem {
  label: string;
  value: React.ReactNode;
  fullWidth?: boolean;
  scrollable?: boolean;
}

interface DetailsModalProps {
  open: boolean;
  onClose: () => void;
  title: string;

  header?: {
    title: string;
    subtitle?: string;
    status?: React.ReactNode;
  };

  data: DetailItem[];

  actions?: Array<{
    label: string;
    onClick?: () => void;
    variant?: CustomButtonVariant;
  }>;
}

const DetailsModal: React.FC<DetailsModalProps> = ({
  open,
  onClose,
  title,
  header,
  data,
  actions,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          fontWeight: 700,
          pb: 1,
          fontSize: 18,
          color: "shadesOfDark.dark",
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent sx={{ pt: 1, overflowX: "hidden" }}>
        {header && (
          <Box mb={2}>
            <Typography fontWeight={700} fontSize={16}>
              {header.title}
            </Typography>
          </Box>
        )}

        <Grid container spacing={2}>
          {data.map((item, index) => (
            <Grid
              item
              xs={item.fullWidth ? 12 : 6}
              key={`${item.label}-${index}`}
              sx={{ minWidth: 0 }}
            >
              <Typography fontSize={14} color="text.secondary">
                {item.label}
              </Typography>

              <Typography
                fontSize={14}
                fontWeight={600}
                sx={{
                  wordBreak: "break-word",
                  overflowWrap: "anywhere",
                  ...(item.scrollable && {
                    maxHeight: 120,
                    overflowY: "auto",
                  }),
                }}
              >
                {item.value != null ? item.value : "-"}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        {actions?.map((action, index) => (
          <CustomButton
            key={index}
            title={action.label}
            onClick={action.onClick}
            variant={action.variant}
          />
        ))}
      </DialogActions>
    </Dialog>
  );
};

export default DetailsModal;
